const BookActiveIcon = () => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13.75 2.75H38.5V35.75H13.75V2.75Z" fill="#F7FAFF" />
    <path
      d="M7.93203 38.5C7.93203 35.75 9.19531 35.75 10.3684 35.75H11V2.75H8.25C6.72891 2.75 5.5 3.97891 5.5 5.5V38.5C5.5 40.0211 6.72891 41.25 8.25 41.25H38.5V38.5H7.93203Z"
      fill="#F7FAFF"
    />
  </svg>
);

export default BookActiveIcon;
